<template>
  <div class="data-card">
    <div class="flex-row flex-align-center">
      <div class="label flex-1">{{ title }}</div>
      <slot name="right">
        <div class="fz-14 mr-16" v-if="showTime">统计时间: {{ statisticsTime }}</div>
        <div class="time-select">
          <div class="item" :class="{ active: index === timeIndex }" @click="selectTime(index, item.value)" v-for="(item, index) in timeList" :key="index">{{ item.label }}</div>
        </div>
      </slot>
    </div>
    <div class="info-wrap">
      <div class="item" v-for="(item, index) in list" :key="index">
        <template v-if="item.length">
          <div v-for="(item, index) in item" :key="index" :style="{ marginTop: index ? '40px': '0' }">
            <div class="num" v-if="item.isDecimals">
              <span class="fz-14">￥</span>{{ nums(item.number)[0] }}<span class="fz-14">.{{ nums(item.number)[1] }}</span>
            </div>
            <div class="num" v-else>{{ item.number }}<span v-if="item.isRate" class="fz-16">%</span></div>
            <div class="text">
              <span class="mr-4">{{ item.label }}</span>
              <el-tooltip :content="item.desc" v-if="item.desc">
                <i class="iconfont icon-a-help-circle-obangzhu-xian"></i>
              </el-tooltip>
            </div>
          </div>
        </template>
        <template v-else>
          <div class="num" v-if="item.isDecimals">
            <span class="fz-14">￥</span>{{ nums(item.number)[0] }}<span class="fz-14">.{{ nums(item.number)[1] }}</span>
          </div>
          <div class="num" v-else>{{ item.number }}<span v-if="item.isRate" class="fz-16">%</span></div>
          <div class="text">
            <span class="mr-4">{{ item.label }}</span>
            <el-tooltip :content="item.desc" v-if="item.desc">
              <i class="iconfont icon-a-help-circle-obangzhu-xian"></i>
            </el-tooltip>
          </div>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import {calDate} from '@/utils/common';
import {format} from 'date-fns';
export default {
  name: 'dataCard',
  props: {
    title: {
      type: String,
      default: ''
    },
    list: {
      type: Array,
      default: _ => []
    },
    timeList: {
      type: Array,
      default: _ => [
        { value: 1, label: '昨日' },
        { value: 7, label: '7天' },
        { value: 15, label: '15天' },
        { value: 30, label: '30天' },
        { value: 90, label: '90天' },
        { value: 180, label: '180天' }
      ]
    },
    showTime: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      timeIndex: 0,
      statisticsTime: ''
    }
  },
  computed: {
    nums() {
      return (num = '0.00') => (+num).toFixed(2).split('.')
    }
  },
  methods: {
    reset(value) {
      this.timeIndex = this.timeList.findIndex(item => item.value === value)
      this.setTimeText(value)
    },
    setTimeText(value) {
      const [start_time, end_time] = calDate(value);
      const startTimeText = format(start_time, 'yyyy/MM/dd');
      const endTimeText = format(end_time, 'yyyy/MM/dd');
      this.statisticsTime = `${startTimeText}${this.timeIndex > 1 ? '-' + endTimeText : ''}`
    },
    selectTime(index, value) {
      this.timeIndex = index
      this.setTimeText(value)
      this.$emit('submit', { date_type: value })
    }
  }
}
</script>

<style lang="less" scoped>
.data-card {
  border-bottom: 1px solid #eee;
  padding-bottom: 32px;
  .label {
    font-size: 16px;
    font-weight: bold;
  }
  .time-select {
    display: flex;
    align-items: center;
    border: 1px solid #eee;
    border-radius: 2px;
    font-size: 14px;
    .item {
      padding: 4px 12px;
      cursor: pointer;
      &.active {
        color: @color-primary;
      }
      &:nth-child(n+2) {
        border-left: 1px solid #eee;
      }
    }
  }
  .info-wrap {
    display: flex;
    flex-wrap: wrap;
    margin-top: 32px;
    padding: 0 24px;
    .item {
      display: flex;
      flex-direction: column;
      width: 20%;
      padding-left: 24px;
      box-sizing: border-box;
      .num {
        font-size: 24px;
        color: #333;
        font-weight: bold;
        font-family: HelveticaNeue-Bold, HelveticaNeue;
      }
      .text {
        font-size: 14px;
        color: #666;
        margin-top: 12px;
        display: flex;
        align-items: center;
      }
      &:nth-child(n+6) {
        margin-top: 40px;
      }
    }
  }
}
</style>
